import { useContext, useEffect } from 'react';

import { MessagingContext } from '@sorare/wallet-shared';
import type { GeneratedKey } from '@sorare/wallet-shared';

import { useAuthContext } from '#src/contexts/auth/index.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useWalletDrawerContext } from '#src/contexts/walletDrawer/index.tsx';
import { formatUpdateUserErrors } from '#src/lib/http.ts';

export const useRegisterGenerateKeys = () => {
  const { registerHandler } = useContext(MessagingContext)!;
  const { updateUser } = useAuthContext();
  const { setCurrentTab, hideWallet } = useWalletDrawerContext();
  const { currentUser } = useCurrentUserContext();

  useEffect(() => {
    if (currentUser?.email) {
      registerHandler<GeneratedKey>(
        'generatedKey',
        async ({
          address,
          passwordHash,
          userPrivateKey,
          userPrivateKeyBackup,
          starkKey,
          wallet,
        }) => {
          const walletParams = wallet
            ? { wallet }
            : {
                starkKey,
                sorareAddress: address,
                sorarePrivateKey: userPrivateKey,
                sorarePrivateKeyBackup: userPrivateKeyBackup,
              };

          const { errors } = await updateUser({
            ...walletParams,
            passwordHash,
          });

          if (errors) return { error: formatUpdateUserErrors(errors) };
          return {};
        }
      );
    }
    return () => {};
  }, [
    currentUser?.email,
    hideWallet,
    registerHandler,
    setCurrentTab,
    updateUser,
  ]);
};
